/**
 * Configuration for custom credit card types supported by payment-tokenization.
 * Each card type includes its identifying regex patterns and maximum length.
 * Consumed by the Tokenex integration to recognize additional card types.
 *
 * @TODO implement elo
 */
export const customCardTypesConfig = [
  {
    type: 'americanExpress',
    validRegex: '^3[47]\\d{13}$',
    maxLength: 15,
    possibleRegEx: '^3[47]\\d{0,13}$',
  },
  {
    type: 'dankort',
    validRegex: '^5019\\d{12}$',
    maxLength: 16,
    possibleRegEx: '^5019\\d{0,12}$',
  },
  {
    type: 'dinersclub',
    validRegex: '^(3[68][0-9]|30[0-5])\\d{11}$',
    maxLength: 14,
    possibleRegEx: '^(3[68][0-9]|30[0-5])\\d{0,11}$',
  },
  {
    type: 'discover',
    validRegex: '^(6011|65\\d{2}|64[4-9]\\d|622\\d)\\d{12}$',
    maxLength: 16,
    possibleRegEx: '^(6011|65\\d{2}|64[4-9]\\d|622\\d)\\d{0,12}$',
  },
  {
    type: 'eurocard',
    validRegex: '^5(4130610|5595188)\\d{8}$',
    maxLength: 16,
    possibleRegEx: '^5(4130610|5595188)\\d{0,8}$',
  },
  {
    type: 'hipercard',
    validRegex:
      '^(384100|384140|384160|606282|637095|637568|60(?!11)[0-9]{4})\\d{9,14}$',
    maxLength: 19,
    possibleRegEx:
      '^(384100|384140|384160|606282|637095|637568|60(?!11)[0-9]{4})\\d{0,14}$',
  },
  {
    type: 'jcb',
    validRegex: '^35(28|29|[3-8]\\d)\\d{12,15}$',
    maxLength: 16,
    possibleRegEx: '^35(28|29|[3-8]\\d)\\d{0,15}$',
  },
  {
    type: 'maestro',
    validRegex:
      '^((5018|5020|5038|5893|6304|6759|6761|6762|6763|6304|6706|6709|6771)\\d{2})|(676770|676774)\\d{6,13}$',
    maxLength: 19,
    possibleRegEx:
      '^((5018|5020|5038|5893|6304|6759|6761|6762|6763|6304|6706|6709|6771)\\d{2})|(676770|676774)\\d{0,13}$',
  },
  {
    type: 'masterCard',
    validRegex:
      '^(5[1-5]\\d{4}|677189|222[1-9]\\d{2}|22[3-9]\\d{3}|2[3-6]\\d{4}|27[01]\\d{3}|2720\\d{2})\\d{10,13}$',
    maxLength: 16,
    possibleRegEx:
      '^(5[1-5]\\d{4}|677189|222[1-9]\\d{2}|22[3-9]\\d{3}|2[3-6]\\d{4}|27[01]\\d{3}|2720\\d{2})\\d{0,13}',
  },
  {
    type: 'unionPay',
    maxLength: 19,
    validRegex: '^62[^2]\\d{13,16}$',
    possibleRegEx: '^62[^2]\\d{0,16}$',
  },
  {
    type: 'visa',
    validRegex: '^4\\d{12}(\\d{3})?(\\d{3})?$',
    maxLength: 19,
    possibleRegEx: '^4\\d{0,12}(\\d{3})?(\\d{3})?$',
  },
] as const;

/**
 * Type representing all credit card types payment-tokenization can handle.
 * Also includes 'unknown' for unrecognized card types.
 */
export type CustomCardType =
  | (typeof customCardTypesConfig)[number]['type']
  | 'unknown';

/**
 * Type containing the shape of the customCardTypesConfig object.
 */
export type CustomCardTypesConfig = typeof customCardTypesConfig;
